var _polygon, _rect, _path, _path2, _rect2, _circle, _circle2, _circle3, _circle4, _path3, _path4, _path5, _path6, _path7, _path8, _circle5, _path9, _path10, _path11, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrivermanage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a103f326-996f-4fea-8e69-572a052820ff",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 825.7666,
    height: 640.565,
    viewBox: "0 0 825.7666 640.565",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "performance_overview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "479.735 627.22 288.489 627.22 294.972 542.943 473.252 542.943 479.735 627.22",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 278.76465,
    y: 617.49611,
    width: 213.93566,
    height: 19.4487,
    fill: "#e6e6e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M937.51223,129.7175H206.5654a19.4487,19.4487,0,0,0-19.4487,19.4487V594.86549H956.96093V149.1662A19.4487,19.4487,0,0,0,937.51223,129.7175Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M187.1167,594.86549V667.7981a19.44869,19.44869,0,0,0,19.4487,19.44869H937.51223a19.44869,19.44869,0,0,0,19.4487-19.44869V594.86549Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.89739,
    y: 40.51812,
    width: 693.67017,
    height: 388.97393,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 385.73248,
    cy: 510.52828,
    r: 19.4487,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.52625,
    cy: 53.25663,
    r: 3.69086,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.53585,
    cy: 53.25663,
    r: 3.69086,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.54544,
    cy: 53.25663,
    r: 3.69086,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M983.46079,392.77548s5.94476,77.28191-2.3779,79.65981-38.04648,20.21219-85.60458,15.45638c0,0-46.36915,24.968-39.23543,1.189s39.23543-17.83429,39.23543-17.83429,57.06972-11.88953,59.44762-20.21219-7.13371-42.80229-3.56685-43.99124S983.46079,392.77548,983.46079,392.77548Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#ffb8b8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M979.46079,393.77548s5.94476,77.28191-2.3779,79.65981-38.04648,20.21219-85.60458,15.45638c0,0-46.36915,24.968-39.23543,1.189s39.23543-17.83429,39.23543-17.83429,57.06972-11.88953,59.44762-20.21219-7.13371-42.80229-3.56685-43.99124S979.46079,393.77548,979.46079,393.77548Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#231f20",
    opacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M912.70176,518.097s4.17769,130.06933,11.31141,146.71466c5.94213,13.865,9.40947,59.07736,10.402,73.79462.199,2.95127.29855,4.67624.29855,4.67624s19.02324,0,20.21219-4.75581,4.75581-57.06971,0-73.71505S961.70176,525.097,961.70176,525.097Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M939.46955,737.33774s-11.88952,3.56686-14.26743,8.32267-41.61334,13.07848-29.72381,19.02324,47.5581-4.75581,47.5581-4.75581,19.02324-1.18895,17.83429-8.32267-5.5188-15.92356-5.5188-15.92356Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M972.76022,741.13856s-11.88952,3.56685-14.26743,8.32266S916.87945,762.5397,928.769,768.48446s47.5581-4.75581,47.5581-4.75581,19.02324-1.18895,17.83428-8.32266-5.51879-15.92356-5.51879-15.92356Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M922.82422,524.7492l16.64533,28.53486,27.77989,99.21045s-2.81189,91.022.755,91.022,22.5901,5.94476,23.779,0c1.00432-5.02161,14.32089-53.12538,7.6832-85.14314a409.42026,409.42026,0,0,1-8.30805-61.42572l-2.942-55.55306s11.88953-21.40115-1.18895-24.968S922.82422,524.7492,922.82422,524.7492Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 751.1639,
    cy: 183.39816,
    r: 28.53486,
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M934.71374,332.1389s4.75581,38.04648,3.56686,40.42438,28.53486-26.15695,28.53486-26.15695-10.70057-16.64534-8.32267-24.968Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.29508,370.18538s-33.29067-23.779-34.47962-28.53486l-24.968,21.40114-4.24262-5.05012s-19.53643,19.31755-19.53643,27.64022-1.189,33.29067,2.3779,40.42439-10.70057,97.4941-10.70057,97.4941,11.88952,10.70057,13.07848,11.88952,48.74705-7.13371,48.74705-7.13371,23.779-2.37791,23.779-5.94476-7.13372-57.06972-4.75581-71.33715S1001.29508,370.18538,1001.29508,370.18538Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#575a89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M926.0919,298.8612c3.9005-1.38824,8.20351-2.10118,12.18054-.95035,5.6287,1.62879,9.52706,6.5627,13.7317,10.64389s10.101,7.69757,15.6374,5.77843a9.168,9.168,0,0,1,1.75135-6.77095,6.22705,6.22705,0,0,0,1.55507-2.58815c.23654-1.52831-1.04861-2.84646-1.434-4.34418-.67535-2.62464,1.176-6.21763-1.10019-7.68865-.60082-.3883-1.36154-.47683-1.94789-.88664-2.30122-1.60839.25422-5.6087-1.26727-7.96828a4.86629,4.86629,0,0,0-1.72891-1.44229c-11.0327-6.43748-24.52485-6.45515-37.29729-6.293-1.77808.02258-4.2535.90568-3.752,2.61171-2.41382-1.73266-5.57461.70029-7.52025,2.946l-3.98228,4.59642a35.41012,35.41012,0,0,0-4.86669,6.58314c-1.21651,2.32636-1.48546,5.90289.9356,6.9171-1.8-.754-3.98348,9.90762,4.31446,8.15345C916.12254,307.13963,920.84835,300.72747,926.0919,298.8612Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.83538,
    y: 65.79811,
    width: 655.73993,
    height: 326.67429,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4243,
    y: 113.80551,
    width: 143.32069,
    height: 125.17652,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 313.69839,
    y: 114.18199,
    width: 142.88963,
    height: 124.80003,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 528.69509,
    y: 112.95777,
    width: 144.29131,
    height: 126.02426,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4243,
    y: 293.62072,
    width: 140.1765,
    height: 12.94905,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 96.4243,
    y: 316.41837,
    width: 70.23225,
    height: 12.94905,
    fill: "#009ddd"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 316.03407,
    y: 293.62072,
    width: 140.1765,
    height: 12.94905,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 316.03407,
    y: 316.41837,
    width: 70.23225,
    height: 12.94905,
    fill: "#009ddd"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 530.15359,
    y: 293.62072,
    width: 140.1765,
    height: 12.94905,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 530.15359,
    y: 316.41837,
    width: 70.23225,
    height: 12.94905,
    fill: "#009ddd"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 359.58712,
    cy: 266.25839,
    r: 6.61746,
    fill: "#009ddd"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 384.70535,
    cy: 266.25839,
    r: 6.61746,
    fill: "#e6e6e6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 409.82358,
    cy: 266.25839,
    r: 6.61746,
    fill: "#e6e6e6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.96641,
    cy: 266.25839,
    r: 6.61746,
    fill: "#009ddd"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 168.08465,
    cy: 266.25839,
    r: 6.61746,
    fill: "#009ddd"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.20288,
    cy: 266.25839,
    r: 6.61746,
    fill: "#e6e6e6"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 581.54985,
    cy: 266.25839,
    r: 6.61746,
    fill: "#009ddd"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 606.66808,
    cy: 266.25839,
    r: 6.61746,
    fill: "#009ddd"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 631.78631,
    cy: 266.25839,
    r: 6.61746,
    fill: "#009ddd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M787.95744,269.00126a36.68614,36.68614,0,1,0,36.68614,36.68613A36.794,36.794,0,0,0,787.95744,269.00126Zm0,11.00584a11.00584,11.00584,0,1,1-11.00584,11.00584,11.04276,11.04276,0,0,1,11.00584-11.00584Zm0,52.98324a26.72558,26.72558,0,0,1-22.01168-11.74662c.17638-7.33722,14.67446-11.37623,22.01168-11.37623s21.83531,4.039,22.01168,11.37623a26.77008,26.77008,0,0,1-22.01168,11.74662Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#009ddd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M572.25991,269.61337A36.68614,36.68614,0,1,0,608.946,306.29951,36.794,36.794,0,0,0,572.25991,269.61337Zm0,11.00584a11.00585,11.00585,0,1,1-11.00584,11.00585,11.04277,11.04277,0,0,1,11.00584-11.00585Zm0,52.98325a26.72557,26.72557,0,0,1-22.01168-11.74662c.17637-7.33723,14.67445-11.37623,22.01168-11.37623s21.8353,4.039,22.01168,11.37623a26.77012,26.77012,0,0,1-22.01169,11.74662Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#009ddd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M355.20135,269.42513a36.68614,36.68614,0,1,0,36.68613,36.68614A36.794,36.794,0,0,0,355.20135,269.42513Zm0,11.00584a11.00585,11.00585,0,1,1-11.00584,11.00585A11.04277,11.04277,0,0,1,355.20135,280.431Zm0,52.98325a26.72561,26.72561,0,0,1-22.01169-11.74662c.17638-7.33723,14.67446-11.37623,22.01169-11.37623s21.8353,4.039,22.01168,11.37623a26.77014,26.77014,0,0,1-22.01169,11.74662Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#009ddd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1008.42879,403.47605s5.94477,77.28191-2.3779,79.65981-38.04648,20.2122-85.60458,15.45639c0,0-46.36915,24.968-39.23543,1.189s39.23543-17.83429,39.23543-17.83429,57.06972-11.88952,59.44762-20.21219-7.13371-42.80229-3.56685-43.99124S1008.42879,403.47605,1008.42879,403.47605Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M982.27184,372.56328l19.02324-2.3779s19.02324,36.85753,8.32267,42.80229-38.04648,10.70057-38.04648,8.32267S982.27184,372.56328,982.27184,372.56328Z",
    transform: "translate(-187.1167 -129.7175)",
    fill: "#575a89"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrivermanage1);
export default __webpack_public_path__ + "static/media/drivermanage1.47fdb118c37c9047a7848c90f9faacad.svg";
export { ForwardRef as ReactComponent };